// koordinat.js — KOORDİNAT: AIP BİÇİMİ (DDMMSS.ssN / DDDMMSS.ssE) ↔ ONDALIK DERECE — TEK KAYNAK (1 Eki 2026)
//
// 🔑 Serkan (1 Eki 2026, EDIT AIRPORT LTAC): *"burada north east south west girişleri yok, nasıl doğru
//    konumluyor meydanı"* → B: AIP biçimi · giriş YALNIZ AIP biçimi (*"A"*) · listede de AIP biçimi (*"a"*) ·
//    *"digitler tam olmalı, gerekirse 0 ile başlamalı, küsurat yoksa .00 olmalı ki eksik girmeyelim; hücrede
//    digitleri verebilir miyiz?"* → SABİT GENİŞLİK: enlem 2+2+2 hane . 2 hane + N/S, boylam 3+2+2 . 2 + E/W.
//    Eksik hane REDDEDİLİR; kutuda şablon (DDMMSS.ssN) görünür. Tek tip: liste ve EDIT de aynı biçimi gösterir.
// 🔴 ÖNCESİ: ondalık derece, yön yalnız İŞARETLE (− = güney/batı) — formda da Help'te de yazmıyordu; eksi
//    unutulursa meydan dünyanın öbür yarısına düşerdi (JFK −73.78 yerine 73.78 → Orta Asya).
// Veritabanı ONDALIK tutar (OurAirports, FTL, saat dilimi, gece/gündüz hepsi ondalık okur) — çeviri yalnız ekranda.
// Web'de de iPad'de de N/S–E/W biçimleyici yoktu (1 Eki'de arandı); koordinat gösteren/alan her yer BURAYA bağlanır.

const DESEN = {
  lat: /^(\d{2})(\d{2})(\d{2}\.\d{2})([NS])$/,
  lon: /^(\d{3})(\d{2})(\d{2}\.\d{2})([EW])$/,
};
const SINIR = { lat: 90, lon: 180 };

/** Kutunun içinde görünen hane şablonu. */
export const KOORDINAT_SABLON = { lat: 'DDMMSS.ssN', lon: 'DDDMMSS.ssE' };
/** LTAC kaydından (40.128101, 32.995098) — AIP'ten alıntı değil. */
export const KOORDINAT_ORNEK = { lat: '400741.16N', lon: '0325942.35E' };

export const KOORDINAT_HATASI = {
  lat: 'Latitude: every digit as in the AIP — DDMMSS.ss and N or S, e.g. 400741.16N. '
     + 'Start with 0 where needed (052030.00N) and write .00 when the seconds have no decimals.',
  lon: 'Longitude: every digit as in the AIP — DDDMMSS.ss and E or W, e.g. 0325942.35E. '
     + 'Start with 0 where needed (0053000.00E) and write .00 when the seconds have no decimals.',
};

/** AIP biçimi → ondalık derece (6 hane, güney/batı eksi). Geçersizse NaN — tahmin edilmez, eksik hane tamamlanmaz. */
export function aipOndalik(v, eksen) {
  const m = DESEN[eksen].exec(String(v ?? '').trim());
  if (!m) return NaN;
  const d = Number(m[1]), dk = Number(m[2]), sn = Number(m[3]);
  if (dk >= 60 || sn >= 60) return NaN;
  const deger = d + dk / 60 + sn / 3600;
  if (deger > SINIR[eksen]) return NaN;
  const isaretli = (m[4] === 'S' || m[4] === 'W') ? -deger : deger;
  return Math.round(isaretli * 1e6) / 1e6;
}

/** Ondalık derece → AIP biçimi, saniye İKİ HANE kesirli (yuvarlama saniyeye/dakikaya/dereceye taşar). Değer yoksa ''. */
export function ondalikAip(v, eksen) {
  if (typeof v !== 'number' || !isFinite(v)) return '';
  const top = Math.round(Math.abs(v) * 360000);            // saniyenin yüzde biri
  const d = Math.floor(top / 360000), dk = Math.floor((top % 360000) / 6000), ys = top % 6000;
  const guneyBati = v < 0 && top > 0;
  const harf = eksen === 'lat' ? (guneyBati ? 'S' : 'N') : (guneyBati ? 'W' : 'E');
  return String(d).padStart(eksen === 'lat' ? 2 : 3, '0') + String(dk).padStart(2, '0')
       + String(Math.floor(ys / 100)).padStart(2, '0') + '.' + String(ys % 100).padStart(2, '0') + harf;
}

export const koordinatGecerli = (v, eksen) => isFinite(aipOndalik(v, eksen));
